import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  /** Subject used for knowing if there are any http requests in progress.
   * Use getIsHttpLoading$() to get the observable to subscribe to.
   * Use setIsHttpLoading$() to set the value to the subject.
   */
  private isHttpLoading$: BehaviorSubject<boolean>;

  constructor() {
    this.isHttpLoading$ = new BehaviorSubject(false);
  }

  /** For getting an observable which will return true if there is any http request in progress */
  public getIsHttpLoading$(): Observable<boolean> {
    return this.isHttpLoading$.asObservable();
  }

  /** For setting a value to the isHttpLoading$ subject
   * @param isHttpLoading - whether any http request is in progress
   */
  public setIsHttpLoading$(isHttpLoading: boolean): void {
    setTimeout(() => {
      this.isHttpLoading$.next(isHttpLoading);
    }, 0);
  }
}
